import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Form, Modal, message, Button, Col } from "antd";
import { ClientList } from "../../Client/components/ClientList";
import { documentAction } from "../../DocumentSection/state/actions";
import { EditTwoTone, ExclamationCircleOutlined, PlusCircleFilled } from "@ant-design/icons";
import { CorpSigners } from "../../DocumentSection/components/CorpSigners";
import { generateFullNameFromObj } from "../../Common/utils/extraFunctions";

const AddSeller = ({  fieldEmpty, setFieldIsEmpty, delegate, setListingModalFields, listingModalFields ,addCorps,addPersons,setAddPerson,setAddCorps}) => {
  const [showClientListModal, setShowClientListModal] = useState(false);
  const [showSellersModal, setShowSellersModal] = useState(false);
  const [input, setInput] = useState("");
  // const [drawerVisible, setDrawerVisible] = useState(false);
  const dispatch = useDispatch();
  let { clientsArray,  entityName, currentlySelectedCorpData,isCorpTrue } = useSelector((state) => state.documentSection.CorpReducer);
  const { CurrentPdfImportData } = useSelector((state) => state.documentSection.urlImportReducer);
  let delegateOwnerId = listingModalFields?.delegateSeller?.id;

  const isPdfImported = Object.keys(CurrentPdfImportData).length > 0;
  const [showSearchInput, setShowSearchInput] = useState(true);
  const [value, setValue] = useState("");
  const [page, setPage] = useState([1]);
  const [isfilterArchive, setIsFilterArchive] = useState("");

  const handleCancel = () => {
    setValue("")
    setShowClientListModal(false);
  };
  // when the user select any client in the clientList
  const handleClientSelected = (selectedClient) => {
    const clients = clientsArray || [];

    if (clients.length >= 10) {
      message.error(`Maximum number of clients already added.`);
      return;
    }

    const isCorp = currentlySelectedCorpData?.isCorp;
    const existingIndex = clientsArray.findIndex((el) => el.key === currentlySelectedCorpData?.key);

    if (isCorpTrue && existingIndex !== -1) {
      const existingSigners = clientsArray[existingIndex].signers || [];

      if (existingSigners.some((el) => el.personId === selectedClient._id)) {
        message.error(`Client already exists in the signers list.`);
        return;
      }
      clientsArray[existingIndex].signers = [...(existingSigners || []), { fullName: generateFullNameFromObj(selectedClient), personId: selectedClient._id }];

      dispatch(documentAction.setCorpState({ clientsArray }));
      message.success(`Signer Added!`);
    } else if (!selectedClient?.isCorp && clients.some((client) => client.personId === selectedClient._id)) {
      message.error(`Client already exists in the sellers list.`);
      return;
    } else {
      clientsArray.push({
        fullName:generateFullNameFromObj(selectedClient),
        personId: selectedClient._id,
        isCorp: false,
        signers: [],
      });
      dispatch(documentAction.setCorpState({ clientsArray }));
      message.success(`Seller Added!`);
    }

    // onChange({ nameOfSeller, sellerDetails: selectedRows }, "searchBuyerType");
  };

  function onChange(value, key) {
    const fieldEmptyUpdated = listingModalFields;
    fieldEmptyUpdated[key] = value;
    
    setListingModalFields({ ...fieldEmptyUpdated });
  }

  const handleDeleteClientOrCorp = (element, type, item) => {
    if (type === "CORP") {
      handleCorpDelete(element);
      return;
    } else if (type === "SIGNERS") {
      const newDataIndex = clientsArray.findIndex((el) => el.key === element.key);
      if (newDataIndex !== -1) {
        clientsArray[newDataIndex].signers = clientsArray[newDataIndex].signers.filter((signer) => {
          if (item.personId) {
            return signer.personId !== item.personId;
          } else {
            return signer.key !== item.key;
          }
        });
      }
    } else {
      clientsArray = clientsArray.filter((el) => {
        if (element.personId) {
          return el.personId !== element.personId;
        } else {
          return el.key !== element.key;
        }
      });
    }
  
    dispatch(documentAction.setCorpState({ clientsArray }));
  };
  

  const handleAdd = () => {
    setShowClientListModal(false);
  }
const handleCancelModal=()=>{
  setShowSellersModal(false)
}
  const handleCorpDelete = (element = {}) => {
    Modal.confirm({
      title: `Are you sure you want to remove ${element.fullName} from this form?`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      content: "Note: This will also remove all the signers associated with it.",
      onOk() {
        let newData = clientsArray.filter((el) => el.key !== element.key);
        dispatch(documentAction.setCorpState({ clientsArray: newData }));
      },
      onCancel() {},
    });
  };


  return (
    <>
   <Col xs={24} sm={24} md={24} lg={12} xl={12}>
   {clientsArray?.length > 0 ? (
          <Form.Item
            name="seller"
            label={
              <div style={{ display: "flex", alignItems: "center"}} o>
                <div style={{ marginLeft: "5px", width: "100%", fontSize: "20px", color: "#1990ff", cursor: "pointer" }}>Edit Sellers</div>
                <span style={{ marginLeft: "10px" }}>
                  <EditTwoTone style={{ fontSize: "20px", color: "#085191", cursor: "pointer" }}   onClick={() => setShowSellersModal(true)}/>
                </span>
              </div>
            }
            rules={isPdfImported?[
              {
                required: true,
                message: "",
              }
            ]:[]}
          >
            <div style={{ display: "flex", flexDirection: "column", whiteSpace: "nowrap", overflowX: "auto", marginLeft: "10px" }}>
            <div>
                {clientsArray
                  ?.filter((ele) => !ele?.isCorp)
                  ?.map((item, index) => {
                    return (
                      <span key={index} style={{ marginRight: "5px" }}>
                        <span style={{ fontSize: "17px", display: "inline-block", verticalAlign: "middle", lineHeight: "45px",fontWeight:"bold" }}>{item?.fullName}</span>
                        {index !== clientsArray?.filter((ele) => !ele?.isCorp)?.length - 1 && ","}
                      </span>
                    );
                  })}
              </div>
              <div>
                {clientsArray
                  ?.filter((ele) => ele?.isCorp === true)
                  ?.map((item, index) => {
                    return (
                      <span key={index} style={{ marginRight: "10px" }}>
                        <span style={{ display: "inline-block", verticalAlign: "middle", lineHeight: "45px" }}>
                          <span style={{fontSize: "17px",fontWeight:"bold",marginRight:"3px"}}>{item?.fullName?.toUpperCase()}</span>(
                          {item?.signers?.length &&
                            item?.signers?.map((el, i) => {
                              return (
                                <span key={i} style={{ marginRight: i !== item?.signers?.length - 1 ? "5px" : "" }}>
                                  <span style={{ fontSize: "15px",fontWeight:"normal" }}>{el?.fullName}</span>
                                  {i !== item?.signers?.length - 1 && ","}
                                </span>
                              );
                            })}
                          )
                        </span>
                        {index !== clientsArray?.filter((ele) => ele.isCorp === true)?.length - 1 && ","}
                      </span>
                    );
                  })}
              </div>
            </div>
          </Form.Item>
        ) : (
  <div style={{ display: "flex", alignItems: "center" }}     onClick={() => setShowSellersModal(true)}>
    <div
      style={{
        fontSize: "20px",
        color: "#8e959a",
        fontWeight:"bold" ,
        cursor: "pointer",
        marginRight: "8px", // space between text and icon
      }}
    >
     {isPdfImported&&<span style={{ color: "red", marginRight: "5px",marginTop:"5px" }}>*</span>}
      Add Sellers
    </div>
    <div
      style={{
        pointerEvents: delegate && !delegateOwnerId ? "none" : "auto",
      }}
    >
      <PlusCircleFilled
        style={{ fontSize: "22px", color: "#085191", cursor: "pointer" }}
    
      />
    </div>
  </div>)}
</Col>

      {/* <div style={{ width:"100%", marginTop: "20px auto", border:"1px solid red" }}> */}
      <Modal visible={showSellersModal} onOk={() => {}} onCancel={handleCancelModal} footer={false} style={{ marginTop: "-80px", }}>
        <Form layout="horizontal" initialValues={{}} autoComplete="off" style={{maxHeight:"70vh"}}>

          <CorpSigners setPage={setPage} showClientListModal={showClientListModal} source={"SELLER"} setShowClientListModal={setShowClientListModal} handleDeleteClientOrCorp={handleDeleteClientOrCorp} entityName={entityName} delegate={delegate} setListingModalFields={setListingModalFields} onChange={onChange} delegateOwnerId={delegateOwnerId} selectedSellerAgent={listingModalFields?.delegateSeller} addPersons={addPersons} addCorps={addCorps} setAddPerson={setAddPerson} setAddCorps={setAddCorps}  />
        </Form>
        </Modal>
      {/* </div> */}
      <Modal visible={showClientListModal} onOk={() => {}} onCancel={handleCancel} footer={false} style={{ marginTop: "-80px" }}>
        <ClientList listSource={"offerSection"} selectClient={handleClientSelected} searchBuyerNameInOffer={input} handleCancel={handleCancel} page={page} setPage={setPage} showSearchInput={showSearchInput} setShowSearchInput={setShowSearchInput} value={value} setValue={setValue} clientsArray={clientsArray} isCorpTrue={isCorpTrue} currentlySelectedCorpData={currentlySelectedCorpData} delegateOwnerId={delegateOwnerId} isfilterArchive={isfilterArchive} setIsFilterArchive={setIsFilterArchive} setShowClientListModal={setShowClientListModal}/>
        <Button type="primary" style={{bottom:0,left:175,position:"relative",minWidth:"10vw",marginTop:"20px"}} onClick={handleAdd} disabled={isCorpTrue && currentlySelectedCorpData?.signers?.length > 0 ? false : !isCorpTrue && clientsArray?.filter((el) => el.isCorp === false)?.length > 0 ? false : true}>Add</Button>
      </Modal>

    </>
  );
};

export { AddSeller };
